import styles from './Pagination.module.scss'
import usePagination from './usePagination'
import { ArrowLeftIcon, ArrowRightIcon } from '@heroicons/react/24/outline'
import cn from 'classnames'

function Pagination({ totalCount, pageSize = 20, siblingCount, currentPage, onPageChange, className, ...props }) {
  const { paginationRange } = usePagination({ totalCount, pageSize, siblingCount, currentPage })

  if (paginationRange.length <= 1) return null
  return (
    <nav
      className={cn(styles['root'], { [className]: className })}
      {...props}
    >
      <ul>
        <li>
          <button
            disabled={currentPage === 1}
            type="button"
            onClick={() => onPageChange(currentPage - 1)}
          >
            <ArrowLeftIcon />

            <span>Vorige</span>
          </button>
        </li>

        {paginationRange.map((page, index) => {
          const isActive = page === currentPage

          return (
            <li key={page + index}>
              <button
                type="button"
                onClick={() => onPageChange(page)}
                className={cn(styles['page'], { [styles['active']]: isActive })}
              >
                {page}
              </button>
            </li>
          )
        })}

        <li>
          <button
            type="button"
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === Math.ceil(totalCount / pageSize)}
          >
            <span>Volgende</span>

            <ArrowRightIcon />
          </button>
        </li>
      </ul>
    </nav>
  )
}

export default Pagination
